import { render, staticRenderFns } from "./FSTextarea.vue?vue&type=template&id=daa290e4&"
import script from "./FSTextarea.vue?vue&type=script&lang=js&"
export * from "./FSTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports